import React from 'react';
export function ProductShowcase() {
  const benefits = [{
    icon: '💰',
    title: 'Generá ingresos extra',
    desc: 'Aprendé un oficio con demanda real y empezá a cobrar por trabajos que otros no saben hacer.'
  }, {
    icon: '🔌',
    title: 'Dominá la electricidad de verdad',
    desc: 'Comandos, instalaciones, tableros y automatización. Todo lo que necesitás para trabajar con criterio técnico real.'
  }, {
    icon: '🏠',
    title: 'Arreglá tu casa y dejá de pagarle a otros',
    desc: 'Hacé vos mismo las instalaciones, reparaciones y mejoras eléctricas de tu hogar.'
  }, {
    icon: '🚀',
    title: 'Ve resultados rápido',
    desc: 'Material directo y aplicable desde el primer día. Sin vueltas, sin relleno, sin perder tiempo.'
  }, {
    icon: '🛠️',
    title: 'Aprendé un oficio que te da libertad',
    desc: 'Un oficio eléctrico te da independencia para trabajar por tu cuenta, en tus horarios y con tus condiciones.'
  }];
  return <section className="bg-brand-bg text-brand-text px-4 py-10" data-id="element-97">
      <div className="max-w-xl mx-auto" data-id="element-98">
        <p className="text-center text-xs font-bold uppercase tracking-widest text-brand-muted mb-1" data-id="element-99">
          Te presentamos el
        </p>
        <h2 className="text-2xl md:text-3xl font-black text-center mb-3 text-yellow" data-id="element-100">
          ⚡ MEGA PACK MAESTRO ELECTRICISTA
        </h2>
        <p className="text-sm md:text-base text-brand-muted text-center mb-3 leading-relaxed" data-id="element-101">
          El sistema práctico con planos, guías y material aplicable para
          aprender electricidad desde cero y empezar a usarlo de verdad.
        </p>
        <p className="text-sm text-brand-muted text-center mb-8" data-id="element-102">
          Sin teoría inútil. Sin cursos caros. Sin rodeos. Todo organizado,
          claro y listo para que lo descargues y uses hoy mismo.
        </p>

        <h3 className="text-lg md:text-xl font-black text-center mb-5" data-id="element-103">
          ⚡ ¿Qué vas a lograr con el Mega Pack?
        </h3>

        <div className="space-y-3 mb-8" data-id="element-104">
          {benefits.map((b, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-lg p-4" data-id="element-105">
              <p className="font-black text-white mb-1" data-id="element-106">
                {b.icon} {b.title}
              </p>
              <p className="text-sm text-brand-muted leading-relaxed" data-id="element-107">
                {b.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-card border-2 border-yellow rounded-lg p-5" data-id="element-108">
          <p className="text-center text-xs font-bold uppercase tracking-widest text-brand-muted mb-1" data-id="element-109">
            📘 El pack principal para generar ingresos
          </p>
          <h3 className="text-xl font-black text-center text-yellow mb-3" data-id="element-110">
            ⚡ MEGA PACK MAESTRO ELECTRICISTA
          </h3>
          <p className="text-sm text-brand-muted leading-relaxed mb-2" data-id="element-111">
            La guía central del sistema. Todo lo que necesitás para entender la
            lógica de los comandos eléctricos, interpretar planos, conectar
            circuitos de mando y potencia y resolver con criterio técnico real.
          </p>
          <p className="text-sm text-brand-muted leading-relaxed mb-3" data-id="element-112">
            Con esquemas, planos detallados y explicaciones paso a paso pensadas
            para que cualquiera pueda entender y aplicar.
          </p>
          <p className="text-center font-black text-white" data-id="element-113">
            Valor real: <span className="text-yellow" data-id="element-114">$97 USD</span>
          </p>
        </div>
      </div>
    </section>;
}